import React, { Component } from 'react';
import './SingleCouponOverview.scss';
import moment from 'moment';
import { connect } from 'react-redux';
import BaseOverView from './BaseOverview';
import CustomerFilterableDropdown from '../../transactions/CustomerFilterableDropdown';
import { COUPON_TEMPLATE_TYPE, COUPON_FORMATS } from '../../../config/CustomEnums';
@connect(({ customerList, singleCoupon }) => ({
  customerList: customerList.customerList,
  singleCoupon: singleCoupon.singleCoupon,
}))
class SingleCouponOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultOwner: this.props.defaultOwner.owner,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.singleCoupon?.owner?.pk && this.props.singleCoupon?.owner?.pk) {
      this.props.selectedOwner({
        value: this.props.singleCoupon?.owner,
        label: `[${this.props.singleCoupon?.owner?.membershipId}] ${this.props.singleCoupon?.owner?.owner}`
      })
    }
  }

  parseDateTime = (datetimeStr) => {
    return moment(datetimeStr).format('D MMM YYYY (ddd), LT');
  };
  parseCouponExpiryDate = () => {
    const effectiveDate = this.props.singleCoupon?.effectiveDate;
    const expiryDate = this.props.singleCoupon?.expiryDate;
    if (effectiveDate && expiryDate) {
      return `${this.parseDateTime(effectiveDate)} - ${this.parseDateTime(
        expiryDate,
      )}`;
    }
    if (this.props.couponSet.validPeriodType === 'ALL_TIME') {
      return 'All time valid';
    }
    if (this.props.couponSet.validPeriodType === 'ABSOLUTE') {
      return `${effectiveDate ? this.parseDateTime(effectiveDate) : ''} - ${expiryDate ? this.parseDateTime(expiryDate) : ''
        }`;
    }
    if (this.props.couponSet.validPeriodType === 'RELATIVE') {
      return `${this.props.couponSet.numberOfDaysToExpireAfterAcquisition} days since acquiring`;
    }
    return '-';
  };
  parseCouponCodeSetting = (couponCodeSetting) => {
    if (couponCodeSetting === COUPON_FORMATS.COUPON_QR_CODE) {
      return 'QR code'
    }
    if (couponCodeSetting === COUPON_FORMATS.COUPON_BAR_CODE) {
      return 'Barcode'
    }
    if (couponCodeSetting === COUPON_FORMATS.TEXT) {
      return 'Text'
    }
    return '-'
  }
  render() {
    const firstSectionTitle = 'INFORMATION';
    const informationCardFields = [
      { title: "ID", value: this.props.singleCoupon?.pk },
      {
        title: this.props.singleCoupon.template?.offlineFormats ===
          COUPON_TEMPLATE_TYPE.couponCodeImage
          ? 'Image'
          : 'Serial Number',
        value: this.props.singleCoupon.template?.offlineFormats === COUPON_TEMPLATE_TYPE.couponCodeImage
          ? this.props.singleCoupon?.displayImage
          : this.props.singleCoupon?.serialNumber,
      },
      { title: "Reference ID", value: this.props.singleCoupon?.referenceId || '-', },
      { title: "Brand", value: this.props.singleCoupon?.template?.brand?.name || '-', },
      { title: "Store", value: this.props.singleCoupon?.store?.name || '-', },
      { title: "Coupon code setting", value: this.parseCouponCodeSetting(this.props.singleCoupon?.template?.offlineFormats), },
      { title: "Barcode format", value: this.props.singleCoupon?.template?.offlineBarcodeFormat?.name || '-', },
      { title: "Import code", value: this.props.singleCoupon?.code || '-', },
      {
        title: this.props.isTicket ? "Ticket Owner" : "Coupon Owner",
        value: <CustomerFilterableDropdown
          defaultSelectedCustomer={this.props.defaultOwner}
          selectCustomer={this.props.selectedOwner}
        />,
      },
      { title: "Transaction type", value: this.props.singleCoupon?.transactionType || '-', },
      {
        title: this.props.isTicket ? "Ticket Set" : "Coupon Set",
        value: this.props.couponSet?.name
          ? `[ID: ${this.props.couponSet?.pk}] ${this.props.couponSet?.name}`
          : '-',
      },
      { title: "Expiry Date", value: this.parseCouponExpiryDate(), },
    ]
    const secondSectionTitle = 'GENERAL';
    const generalTitleList = ["Status", "Creation time", "Last modified time", "Last modified by",]
    const generalValueList = [
      this.props.singleCoupon?.status,
      this.props.singleCoupon?.detailDisplayCreationDate || "-",
      this.props.singleCoupon?.detailDisplayLastModifiedDate || "-",
      this.props.singleCoupon?.displayLastModifiedBy || "-",
    ]

    return (
      <div>
        <BaseOverView
          className={''}
          title={firstSectionTitle}
          itemTitleList={informationCardFields?.map(item => item.title)}
          itemValueList={informationCardFields?.map(item => item.value)}
        />
        <BaseOverView
          title={secondSectionTitle}
          itemTitleList={generalTitleList}
          itemValueList={generalValueList}
        />

        {/* <BaseOverView
          className={''}
          title={secondSectionTitle}
          itemTitleList={usageTitleList}
          itemValueList={usageValueList}
        /> */}
      </div>
    );
  }
}

export default SingleCouponOverview;
